// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"0512225b","78":"0f53ea09","190":"e93d1f82","205":"63d0c5a5","279":"8c298b40","319":"759fdffa","355":"944d1325","372":"a0a0b205","531":"ce0b5011","764":"1feb7450","765":"37455ccf","806":"edcadb3f","817":"1feb7450","983":"47fafb63"}[chunkId] + ".chunk.css";
};